import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    redBackgroundLeft: {
      backgroundColor: '#C01236',
      color: 'white',
      textAlign: 'right'
    },
    redBackground: {
      backgroundColor: '#C01236',
      color: 'white',
    },
    tdSpace: {
      borderTop: '12px solid #E8E8E8'
    },
    tdPadding: {
      padding: '10px 20px'
    },
    topSeparator: {
      borderTop: '12px solid #E8E8E8'
    },
    bottomSeparator: {
      borderBottom: '12px solid #E8E8E8'
    },
    leftSeparator: {
      borderLeft: '3px solid #E8E8E8'
    },
    rightSeparator: {
      borderRight: '3px solid #E8E8E8'
    },
    rightSeparatorBig: {
      borderRight: '16px solid #E8E8E8'
    },
    leftBorder: {
      borderLeft: '5px solid #C01236'
    },
    rightBorder: {
      borderRight: '5px solid #C01236'
    },
    topBorder: {
      borderTop: '5px solid #C01236'
    },
    bottomBorder: {
      borderBottom: '5px solid #C01236'
    },
    responsiveTable: {
      margiBbottom: '30px',
      overflowX: 'auto'
    },
    table: {
      minWidth: '580px',
      width: '100%',
      borderSpacing: '0',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '18px',
      borderCollapse: 'separate'
    },
    notesTable: {
      padding: '20px 0'
    },
    notestableSpan: {
      paddingRight: '20px'
    }
});

export default styles;
